export default __webpack_public_path__ + "static/media/List_Management.bea24399.png";